/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type sharedMessageHelpers_messages = {
    readonly items: ReadonlyArray<{
        readonly note: {
            readonly serviceId: string | null;
            readonly content: {
                readonly message: string | null;
            } | null;
            readonly anchors: ReadonlyArray<{
                readonly serviceId: string | null;
                readonly content: {
                    readonly message: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "sharedMessageHelpers_messages";
};
export type sharedMessageHelpers_messages$data = sharedMessageHelpers_messages;
export type sharedMessageHelpers_messages$key = {
    readonly " $data"?: sharedMessageHelpers_messages$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"sharedMessageHelpers_messages">;
};



const node: ReaderInlineDataFragment = {
    "kind": "InlineDataFragment",
    "name": "sharedMessageHelpers_messages"
} as any;
(node as any).hash = 'c7cf202a5022a6975161e073e3b8da36';
export default node;
